import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    paddingRight: tokens.spacingHorizontalS
  },
  previewInTeamsButton: {
    // need to float the button to the right
    marginLeft: 'auto',
    marginRight: tokens.spacingHorizontalS
  },
  previewInTeamsButtonWithFilter: {
    marginLeft: 'unset'
  }
});
